import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import { Table } from "react-bootstrap";
import setting from "../setting.json";

const Contact = () => {

    const [list, setList] = useState();

    const getAllContactQuery = async () => {
        await fetch(setting.api + "api/getAllContactQuery", {
            method: "GET",
            mode: "cors",

        })
            .then(response => response.json())
            .then(c => {
                setList(c.data);

            });
    }

    useEffect(() => {
        getAllContactQuery();
    })

    return (
        <>
            <Header />
            <Sidebar />
            <main id="main" className="main">
                <div className="pagetitle">
                    <h1>Contact</h1>
                    <nav>
                        <ol className="breadcrumb">
                            <li className="breadcrumb-item"><a href="index.html">Home</a></li>
                            <li className="breadcrumb-item active">Data</li>
                        </ol>
                    </nav>
                </div>

                <Table striped bordered hover variant="">
                    <thead>
                        <tr>
                            <th>Sr.No.</th>
                            <th>Name</th>
                            <th>Enqury Type</th>
                            <th>Short Descruption</th>

                        </tr>
                    </thead>
                    <tbody>
                        {list && list.map((c, i) =>
                            <tr key={i}>
                                <td>{i + 1}</td>
                                <td>{c.name}</td>
                                <td>{c.email}</td>
                                <td>{c.message}</td>

                            </tr>
                        )}

                    </tbody>
                </Table>
            </main>
            <Footer />
        </>
    )
}
export default Contact;